<template>
  <div>
    <q-form ref="editForm">
      <c-card title="LBLBASEINFO" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline>
            <c-btn v-show="editable && completeEditable && !disabled" :url="completeUrl" :isSubmit="isComplete" :param="fireFightingIssueCheck" mappingType="PUT" label="완료" icon="check" @beforeAction="completeInfo" @btnCallback="completeCallback" />
            <c-btn v-show="editable && confirmEditable && !disabled" :url="confirmUrl" :isSubmit="isConfirm" :param="fireFightingIssueCheck" mappingType="PUT" label="검토요청" icon="check" @beforeAction="confirmInfo" @btnCallback="confirmCallback" />
            <c-btn v-show="editable && isOld && requestEditable && !disabled" :url="requestUrl" :isSubmit="isRequest" :param="fireFightingIssueCheck" mappingType="PUT" label="점검요청" icon="check" @beforeAction="requestInfo" @btnCallback="requestCallback" />
            <c-btn v-show="editable && !disabled" :url="saveUrl" :isSubmit="isSave" :param="fireFightingIssueCheck" :mappingType="mappingType" label="LBLSAVE" icon="save" @beforeAction="saveInfo" @btnCallback="saveCallback" />
            <c-btn v-show="editable" label="삭제" icon="delete_forever" @btnClicked="deleteInfo" />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
            <c-plant required :disabled="disabled" :editable="editable && (requestEditable || !isOld)" type="edit" name="plantCd" v-model="fireFightingIssueCheck.plantCd" />
          </div>
          <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
            <c-datepicker required :disabled="disabled" :editable="editable && (requestEditable || !isOld)" default="today" type="month" name="yearmonth" label="점검년월" v-model="fireFightingIssueCheck.yearmonth" @datachange="checkNameWrite" />
          </div>
          <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
            <c-dept required :disabled="disabled" :editable="editable && (requestEditable || !isOld)" type="edit" label="점검부서" name="deptCd" v-model="fireFightingIssueCheck.deptCd" @datachange="(deptCd, deptName) => checkNameWrite('D', deptName)" />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <c-text required :disabled="disabled" :editable="editable" label="점검명" name="issueCheckName" v-model="fireFightingIssueCheck.issueCheckName" />
          </div>
          <div v-if="isOld && fireFightingIssueCheck.sopFireFightingIssueStepCd !== 'FFI0000001'" class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <c-textarea :disabled="disabled" :editable="editable && confirmEditable" :rows="1" label="이슈종합내용" name="issueContents" v-model="fireFightingIssueCheck.issueContents" />
          </div>
          <div v-if="isOld && fireFightingIssueCheck.sopFireFightingIssueStepCd !== 'FFI0000001'" class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <c-textarea :disabled="disabled" :editable="editable && completeEditable" :rows="1" label="검토내용" name="confirmContents" v-model="fireFightingIssueCheck.confirmContents" />
          </div>
        </template>
      </c-card>
      <c-table ref="table" class="q-mt-sm" :title="resultTableTitle" :columns="resultTableColumn" :gridHeight="grid.height" :data="grid.data" :columnSetting="false" :editable="editable && (confirmEditable || !isOld)" selection="multiple" rowKey="sopFireFightingIssueCheckTargetId" :usePaging="false">
        <template slot="table-chip">
          <q-chip v-for="item in displayCheckResultItems" :key="item.code === null ? 'ALL' : item.code" clickable :outline="selectedResultCode !== item.code" :selected="selectedResultCode === item.code" text-color="white" square color="blue" @click="onClickResult(item)">
            {{ item.codeName }}
          </q-chip>
        </template>
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline>
            <c-btn v-if="editable && (confirmEditable || !isOld)" :showLoading="false" label="LBLADD" icon="add" @btnClicked="addTarget" />
            <c-btn v-if="editable && (confirmEditable || !isOld) && fireFightingIssueCheck.targets.length > 0" label="제외" icon="remove" @btnClicked="deleteTarget" />
          </q-btn-group>
        </template>
      </c-table>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'fireFightingIssueCheckDetail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        sopFireFightingIssueCheckId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      fireFightingIssueCheck: {
        sopFireFightingIssueCheckId: '', // 소방 이슈점검 일련번호
        plantCd: null, // 사업장코드
        sopFireFightingIssueStepCd: '', // 이슈점검 진행상태
        yearmonth: '', // 점검년월
        deptCd: '', // 점검부서
        issueCheckName: '', // 점검명
        issueContents: '', // 이슈사항
        confirmContents: '', // 검토사항
        regUserId: '', // 등록자
        chgUserId: '', // 수정자
        targets: [],
        deleteTargets: [],
      },
      grid: {
        data: [],
        height: '610px',
      },
      mappingType: 'PUT',
      editable: true,
      isSave: false,
      isRequest: false,
      isConfirm: false,
      isComplete: false,
      detailUrl: '',
      saveUrl: '',
      requestUrl: '',
      confirmUrl: '',
      completeUrl: '',
      deleteUrl: '',
      popupOptions: {
        isFull: false,
        width: '70%',
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      checkResultItems: [],
      selectedResultCode: null,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  watch: {
    contentHeight() {
      let height = this.contentHeight - 270;
      if (height < 650) {
        height = 620;
      }
      this.grid.height = String(height) + 'px';
    },
  },
  computed: {
    isOld() {
      return Boolean(this.popupParam.sopFireFightingIssueCheckId);
    },
    displayCheckResultItems() {
      return [
        {
          codeName: '전체',
          code: null,
        },
        ...this.checkResultItems,
      ];
    },
    requestEditable() {
      return this.fireFightingIssueCheck.sopFireFightingIssueStepCd === 'FFI0000001' && this.fireFightingIssueCheck.regUserId === this.$store.getters.user.userId;
    },
    confirmEditable() {
      return this.isOld && (this.fireFightingIssueCheck.sopFireFightingIssueStepCd === 'FFI0000001' || this.fireFightingIssueCheck.sopFireFightingIssueStepCd === 'FFI0000005') && (this.fireFightingIssueCheck.deptCd === this.$store.getters.user.deptCd || this.fireFightingIssueCheck.regUserId === this.$store.getters.user.userId);
    },
    completeEditable() {
      return this.isOld && this.fireFightingIssueCheck.sopFireFightingIssueStepCd === 'FFI0000010' && this.fireFightingIssueCheck.regUserId === this.$store.getters.user.userId;
    },
    disabled() {
      return this.fireFightingIssueCheck.sopFireFightingIssueStepCd === 'FFI0000015';
    },
    resultTableTitle() {
      return !this.isOld || this.fireFightingIssueCheck.sopFireFightingIssueStepCd === 'FFI0000001' ? '평가대상 목록' : '평가대상 점검결과 목록';
    },
    resultTableColumn() {
      let cols = [];
      if (!this.isOld || this.fireFightingIssueCheck.sopFireFightingIssueStepCd === 'FFI0000001') {
        cols = [
          {
            name: 'fireFightingName',
            field: 'fireFightingName',
            label: '소방설비',
            align: 'left',
            sortable: true,
            style: 'width: 250px',
          },
          {
            name: 'sopFireFightingTypeName',
            field: 'sopFireFightingTypeName',
            label: 'LBLTYPE',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
        ];
      } else {
        let yearmonth = this.fireFightingIssueCheck.yearmonth;
        let yearmonthDays = yearmonth ? this.$comm.moment(yearmonth).daysInMonth() : '';
        cols = [
          {
            name: 'fireFightingName',
            field: 'fireFightingName',
            label: '소방설비',
            align: 'left',
            sortable: true,
            style: 'width: 250px',
          },
          {
            name: 'sopFireFightingTypeName',
            field: 'sopFireFightingTypeName',
            label: 'LBLTYPE',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            // required: true,
            name: 'checkDate',
            field: 'checkDate',
            label: '점검일',
            align: 'center',
            sortable: true,
            style: 'width: 120px',
            type: 'date',
            start: yearmonth ? yearmonth + '-01' : void 0,
            end: yearmonth ? yearmonth + '-' + String(yearmonthDays) : void 0,
          },
          {
            // required: true,
            name: 'sopFireFightingIssueResultCd',
            field: 'sopFireFightingIssueResultCd',
            label: '점검결과',
            align: 'center',
            sortable: false,
            setHeader: true,
            isChip: true,
            style: 'width: 100px',
            type: 'select',
            comboItems: this.checkResultItems,
          },
          {
            name: 'issueContents',
            field: 'issueContents',
            label: '이슈사항',
            align: 'left',
            sortable: true,
            style: 'width: 300px',
            type: 'text',
          },
          {
            name: 'attach',
            field: 'attach',
            label: '현장사진',
            align: 'left',
            sortable: false,
            style: 'width: 150px',
            type: 'attach',
            taskClassCd: 'FIRE_FIGHTING_ISSUE_CHECK',
            keyText: 'sopFireFightingIssueCheckTargetId',
          },
        ];
      }
      return cols;
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.fft.fireFightingIssueCheck.get.url;
      this.saveUrl = transactionConfig.fft.fireFightingIssueCheck.update.url;
      this.requestUrl = transactionConfig.fft.fireFightingIssueCheck.request.url;
      this.confirmUrl = transactionConfig.fft.fireFightingIssueCheck.confirm.url;
      this.completeUrl = transactionConfig.fft.fireFightingIssueCheck.complete.url;
      this.deleteUrl = transactionConfig.fft.fireFightingIssueCheck.delete.url;
      // code setting
      this.getCheckResultItems();
      // list setting
      this.getDetail();
    },
    getDetail() {
      if (this.isOld) {
        this.$http.url = this.$format(this.detailUrl, this.popupParam.sopFireFightingIssueCheckId);
        this.$http.type = 'GET';
        this.$http.param = this.searchParam;
        this.$http.request(_result => {
          this.$_.extend(this.fireFightingIssueCheck, _result.data);
          this.grid.data = this.fireFightingIssueCheck.targets;

          this.$emit('setRegInfo', _result.data);
        });
      } else {
        // nothing..
      }
    },
    getCheckResultItems() {
      this.$comm.getComboItems('SOP_FIRE_FIGHTING_ISSUE_RESULT_CD').then(_result => {
        this.$_.forEach(_result, item => {
          this.checkResultItems.push({
            code: item.code,
            codeName: item.codeName,
            attrVal1: item.attrVal1,
          });
        });
      });
    },
    onClickResult(item) {
      this.selectedResultCode = item.code;

      if (this.selectedResultCode === null) {
        this.grid.data = this.fireFightingIssueCheck.targets;
      } else {
        this.grid.data = this.fireFightingIssueCheck.targets.filter(row => item.code === row.sopFireFightingIssueResultCd);
      }
    },
    checkNameWrite(flag, deptName) {
      if (flag === 'D') this.fireFightingIssueCheck.deptName = deptName;
      if (this.fireFightingIssueCheck.yearmonth && this.fireFightingIssueCheck.deptCd) {
        this.$set(this.fireFightingIssueCheck, 'issueCheckName', `${this.fireFightingIssueCheck.yearmonth} ${this.fireFightingIssueCheck.deptName} 소방 이슈점검`);
      }
    },
    addTarget() {
      this.popupOptions.title = '소방설비 검색';
      this.popupOptions.param = {
        type: 'multiple',
        isIssue: true,
        deptCd: this.fireFightingIssueCheck.deptCd,
      };
      this.popupOptions.target = () => import(`${'@/pages/fft/fireFightingPop'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeFireFightingPopup;
    },
    closeFireFightingPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          if (
            this.$_.findIndex(this.fireFightingIssueCheck.targets, {
              sopFireFightingId: item.sopFireFightingId,
            }) === -1
          ) {
            this.fireFightingIssueCheck.targets.push({
              sopFireFightingIssueCheckTargetId: uid(), // 소방 이슈점검 대상 일련번호
              sopFireFightingIssueCheckId: this.popupParam.sopFireFightingIssueCheckId, // 소방 이슈점검 일련번호
              sopFireFightingId: item.sopFireFightingId, // 소방설비 일련번호
              fireFightingName: item.fireFightingName,
              sopFireFightingTypeName: item.sopFireFightingTypeName,
              checkDate: this.$comm.getToday(), // 점검일
              sopFireFightingIssueResultCd: 'FFIR000001', // 이슈점검결과
              issueContents: '', // 이슈사항
              regUserId: this.$store.getters.user.userId, // 등록자
              editFlag: 'C',
            });
          }
        });
      }
    },
    deleteTarget() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        if (!this.fireFightingIssueCheck.deleteTargets) this.fireFightingIssueCheck.deleteTargets = [];
        this.$_.forEach(selectData, item => {
          if (
            this.$_.findIndex(this.fireFightingIssueCheck.deleteTargets, {
              sopFireFightingIssueCheckTargetId: item.sopFireFightingIssueCheckTargetId,
            }) === -1 &&
            item.editFlag !== 'C'
          ) {
            this.fireFightingIssueCheck.deleteTargets.push(item);
          }
          this.fireFightingIssueCheck.targets = this.$_.reject(this.fireFightingIssueCheck.targets, item);
        });
        this.$refs['table'].$refs['compo-table'].clearSelection();
      }
    },
    saveInfo() {
      if (this.isOld) {
        this.saveUrl = transactionConfig.fft.fireFightingIssueCheck.update.url;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = transactionConfig.fft.fireFightingIssueCheck.insert.url;
        this.mappingType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.fireFightingIssueCheck.regUserId = this.$store.getters.user.userId;
              this.fireFightingIssueCheck.chgUserId = this.$store.getters.user.userId;

              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.sopFireFightingIssueCheckId = result.data;
      this.getDetail();
    },
    requestInfo() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result && this.$comm.validTable(this.resultTableColumn, this.fireFightingIssueCheck.targets)) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: '점검요청하시겠습니까?',
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.fireFightingIssueCheck.chgUserId = this.$store.getters.user.userId;

              this.isRequest = !this.isRequest;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    requestCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    confirmInfo() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result && this.$comm.validTable(this.resultTableColumn, this.fireFightingIssueCheck.targets)) {
          // if (
          //   this.$_.findIndex(this.fireFightingIssueCheck.targets, (target) => {
          //     return target.fileExists !== "Y";
          //   }) > -1
          // ) {
          //   window.getApp.$emit("ALERT", {
          //     title: "안내",
          //     message:
          //       "현장 사진이 등록되지 않은 소방설비 점검 대상이 있습니다.\n현장 사진을 넣으시기 바랍니다.",
          //     type: "warning", // success / info / warning / error
          //   });
          //   return;
          // }
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: '검토요청하시겠습니까?',
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.fireFightingIssueCheck.chgUserId = this.$store.getters.user.userId;

              this.isConfirm = !this.isConfirm;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    confirmCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    completeInfo() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result && this.$comm.validTable(this.resultTableColumn, this.fireFightingIssueCheck.targets)) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: '완료하시겠습니까?',
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.fireFightingIssueCheck.chgUserId = this.$store.getters.user.userId;

              this.isComplete = !this.isComplete;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    deleteInfo() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.sopFireFightingIssueCheckId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          });
        },
        // 취소 callback 함수
        cancelCallback: () => {},
      });
    },
  },
};
</script>
